export const LEGAL_DOCUMENTS = [
  {
    slug: 'bireysel-uyelik-ve-kullanim-sozlesmesi',
    title: 'Bireysel Üyelik ve Kullanım Sözleşmesi',
    shortTitle: 'Bireysel Üyelik Sözleşmesi',
    sourceName: 'BİREYSEL ÜYELİK VE KULLANIM SÖZLEŞMESİ.docx',
    summary: 'Platform üyeliği, hesap kullanımı ve kullanıcı yükümlülükleri bu metin kapsamında sunulur.',
    sections: [
      {
        heading: '1. Taraflar',
        paragraphs: [
          'İşbu sözleşme, SYNTERA Eğitim ve Danışmanlık (Şahıs Şirketi Sahibi: Özge Yüksel Babaoğlu) ile www.syntera.tr üzerinden üyelik oluşturan kullanıcı arasında elektronik ortamda akdedilmiştir.',
        ],
      },
      {
        heading: '2. Konu',
        paragraphs: [
          'Bu sözleşme, üyenin site üzerinden sunulan eğitim ve danışmanlık hizmetlerinden yararlanma koşullarını ve tarafların hak ve yükümlülüklerini düzenler.',
        ],
      },
      {
        heading: '3. Üyelik ve Kullanım',
        paragraphs: [
          'Üye, siteye kayıt olurken verdiği bilgilerin doğru ve güncel olduğunu kabul eder. Üyelik kişiye özeldir ve devredilemez. Üye, kullanıcı adı ve şifresinin güvenliğinden sorumludur.',
        ],
      },
      {
        heading: '4. Eğitimlere Erişim',
        paragraphs: [
          'Satın alınan eğitimlere erişim süresi 6 ay ile sınırlıdır. Bu süre sonunda erişim otomatik olarak sona erer. SYNTERA, eğitim içeriklerinde güncelleme ve değişiklik yapma hakkını saklı tutar.',
        ],
      },
      {
        heading: '5. İçerik Kullanımı ve Paylaşım Kuralları',
        paragraphs: [
          'SYNTERA tarafından sunulan tüm içerikler telif hakkı kapsamındadır. Üye aşağıdaki kurallara uymayı kabul eder:',
          'Eczane sahibi eczacı tarafından yapılan satın almalarda içerikler yalnızca aynı eczane bünyesinde çalışan ekip ile sınırlı olarak paylaşılabilir. Bireysel kullanıcılar içerikleri üçüncü kişilerle paylaşamaz.',
        ],
        bullets: [
          'İçerikleri kopyalamamak',
          'İçerikleri kaydetmemek',
          'İçerikleri üçüncü kişilerle paylaşmamak',
          'İçerikleri ticari amaçla kullanmamak',
        ],
      },
      {
        heading: '6. Yasaklı Kullanımlar',
        paragraphs: [
          'Aşağıdaki eylemler kesinlikle yasaktır. Bu tür bir ihlal halinde SYNTERA üyeliği iptal etme, erişimi durdurma ve hukuki süreç başlatma hakkına sahiptir.',
        ],
        bullets: [
          'Eğitim videolarının ekran kaydının alınması',
          'İçeriklerin başka platformlarda yayınlanması',
          'Hesap paylaşımı',
          'Eğitimlerin ticari amaçla yeniden satılması',
        ],
      },
      {
        heading: '7. Görüntü ve Ses Kayıtlarına İlişkin Kurallar',
        paragraphs: [
          'SYNTERA tarafından sunulan canlı eğitimler sırasında katılımcıların görüntü ve ses kayıtları alınabilir. Bu kayıtlar eğitim içeriklerinin bir parçası olarak saklanabilir ve ilgili eğitimi satın alan kullanıcıların erişimine sunulabilir.',
          'Bu kapsamdaki veri işleme faaliyetlerine ilişkin detaylar ayrıca sunulan Görüntü ve Ses Kullanım Açık Rıza Metni kapsamında düzenlenmektedir.',
        ],
      },
      {
        heading: '8. Açık Rıza Kabulü',
        paragraphs: [
          'Canlı eğitimlere katılım kapsamında görüntünün, sesin ve kullanıcı bilgilerinin kayıt altına alınabileceği; bu kayıtların eğitim içeriklerinin bir parçası olarak saklanabileceği ve ilgili eğitimi satın alan diğer kullanıcıların erişimine sunulabileceği bilinerek, bu kapsamda kişisel verilerin işlenmesine ve sınırlı şekilde paylaşılmasına açık rıza verildiği kabul edilir.',
        ],
      },
      {
        heading: '9. Dijital İçerik ve Cayma Hakkı',
        paragraphs: [
          'Satın alınan eğitimler dijital içerik niteliğindedir. Kullanıcıya anında erişim sağlanması nedeniyle cayma hakkı bulunmamaktadır. Üye, satın alma işlemini tamamlayarak bu durumu kabul eder.',
        ],
      },
      {
        heading: '10. Sorumluluk Reddi',
        paragraphs: [
          'Sunulan eğitimler bilgilendirme ve gelişim amaçlıdır. SYNTERA, eğitimler sonucunda elde edilecek ticari veya bireysel sonuçlara ilişkin garanti vermez.',
        ],
      },
      {
        heading: '11. Fikri Mülkiyet',
        paragraphs: [
          'Sitede yer alan tüm içeriklerin hakları SYNTERA’ya aittir. İzinsiz kullanım hukuki yaptırıma tabidir.',
        ],
      },
      {
        heading: '12. KVKK ve Gizlilik',
        paragraphs: [
          'Üyeye ait kişisel veriler yürürlükteki mevzuata uygun olarak işlenir. Detaylar için ilgili aydınlatma metni incelenmelidir.',
        ],
      },
      {
        heading: '13. Fesih',
        paragraphs: [
          'SYNTERA, sözleşmeye aykırı kullanım durumunda üyeliği tek taraflı olarak sonlandırabilir.',
        ],
      },
      {
        heading: '14. Yürürlük',
        paragraphs: [
          'Üye, siteye kayıt olarak bu sözleşmeyi ve tüm kuralları kabul etmiş sayılır.',
        ],
      },
    ],
  },
  {
    slug: 'mesafeli-satis-sozlesmesi',
    title: 'Mesafeli Satış Sözleşmesi',
    shortTitle: 'Mesafeli Satış Sözleşmesi',
    sourceName: 'MESAFELİ SATIŞ SÖZLEŞMESİ.docx',
    summary: 'Online satın alma sürecinde tarafların hak ve yükümlülükleri bu metin ile bilgilendirilir.',
    sections: [
      {
        heading: '1. Taraflar',
        paragraphs: [
          'İşbu sözleşme, SYNTERA Eğitim ve Danışmanlık (Şahıs Şirketi Sahibi: Özge Yüksel Babaoğlu) ile www.syntera.tr üzerinden eğitim satın alan kişi arasında akdedilmiştir.',
        ],
      },
      {
        heading: '2. Konu',
        paragraphs: [
          'Bu sözleşme, alıcının elektronik ortamda satın aldığı dijital eğitim hizmetine ilişkin tarafların hak ve yükümlülüklerini kapsar.',
        ],
      },
      {
        heading: '3. Hizmetin Niteliği',
        paragraphs: [
          'Satın alınan ürün, dijital içerik kapsamında sunulan online eğitim hizmetidir. Eğitimlere erişim süresi 6 ay ile sınırlıdır.',
        ],
      },
      {
        heading: '4. Ödeme ve Teslimat',
        paragraphs: [
          'Ödeme, site üzerinden online olarak gerçekleştirilir. Ödeme tamamlandıktan sonra eğitimlere erişim anında sağlanır.',
        ],
      },
      {
        heading: '5. Cayma Hakkı',
        paragraphs: [
          'Mesafeli sözleşmeler yönetmeliği gereği, dijital içeriklerde anında ifa edilen hizmetlerde cayma hakkı bulunmamaktadır. Alıcı, satın alma işlemini tamamlayarak bu durumu kabul eder.',
        ],
      },
      {
        heading: '6. Kullanım Koşulları',
        paragraphs: [
          'Satın alınan eğitimler kişiye özeldir ve üçüncü kişilerle paylaşılamaz. Eczane sahibi tarafından satın alınan eğitimler ise yalnızca aynı eczane çalışanları ile paylaşılabilir.',
        ],
      },
      {
        heading: '7. Sorumluluk',
        paragraphs: [
          'SYNTERA, teknik aksaklıklar dışında hizmetin sunulmasını sağlar ancak eğitimlerin sonuçlarına ilişkin garanti vermez.',
        ],
      },
      {
        heading: '8. Uyuşmazlık',
        paragraphs: [
          'Uyuşmazlıklarda Türk Hukuku uygulanır.',
        ],
      },
    ],
  },
  {
    slug: 'on-bilgilendirme-formu',
    title: 'Ön Bilgilendirme Formu',
    shortTitle: 'Ön Bilgilendirme Formu',
    sourceName: 'ÖN BİLGİLENDİRME FORMU.docx',
    summary: 'Satın alma öncesinde ürün, fiyat, cayma ve teslim bilgileri özetlenir.',
    sections: [
      {
        heading: 'Satın Alma Öncesi Bilgilendirme',
        paragraphs: [
          'Satın almak üzere olduğunuz hizmet, dijital içerik kapsamında sunulan online eğitimdir.',
        ],
        bullets: [
          'Eğitimlere erişim süresi 6 aydır.',
          'Erişim, ödeme sonrasında anında başlar.',
          'Bu hizmet dijital içerik niteliğinde olduğundan cayma hakkı bulunmamaktadır.',
        ],
      },
      {
        heading: 'Kabul',
        paragraphs: [
          'Satın alma işlemini tamamlayarak yukarıdaki koşulları kabul etmiş olursunuz.',
        ],
      },
    ],
  },
  {
    slug: 'iade-kosullari',
    title: 'İade Koşulları',
    shortTitle: 'İade Koşulları',
    sourceName: 'İADE KOŞULLARI.docx',
    summary: 'İade ve cayma hakkı süreçlerine ilişkin esaslar bu belgede gösterilir.',
    sections: [
      {
        heading: 'İade ve Cayma Politikası',
        paragraphs: [
          'SYNTERA tarafından sunulan eğitimler dijital içerik niteliğindedir. Mesafeli sözleşmeler yönetmeliği gereği anında erişim sağlanan dijital içeriklerde cayma hakkı kullanılamaz.',
          'Satın alma işlemi tamamlandıktan sonra hizmet iptal edilemez ve ücret iadesi yapılmaz.',
          'Ancak teknik bir sorun nedeniyle hizmete erişilememesi durumunda destek sağlanır.',
        ],
        bullets: [
          'İade yapılmaz.',
          'Hizmet iptal edilemez.',
        ],
      },
    ],
  },
  {
    slug: 'kvkk-aydinlatma-metni',
    title: 'KVKK Aydınlatma Metni',
    shortTitle: 'KVKK Aydınlatma Metni',
    sourceName: 'KVKK AYDINLATMA METNİ.docx',
    summary: 'Kişisel verilerin hangi amaçlarla işlendiği ve kullanıcı hakları bu metinde açıklanır.',
    sections: [
      {
        heading: 'Özet Aydınlatma',
        paragraphs: [
          'SYNTERA Eğitim ve Danışmanlık (Özge Yüksel Babaoğlu) olarak kişisel verilerinizin güvenliğine önem veriyoruz.',
          'Ad, soyad, iletişim ve ödeme bilgileriniz; platform kullanım verileriniz; canlı eğitimler sırasında oluşabilecek görüntü ve ses kayıtlarınız 6698 sayılı KVKK kapsamında işlenmektedir.',
          'Kişisel verileriniz; eğitim hizmetlerinin sunulması, üyelik ve satın alma süreçlerinin yürütülmesi, eğitim kayıtlarının oluşturulması ve kullanıcı deneyiminin geliştirilmesi amaçlarıyla işlenir.',
          'Canlı eğitimler sırasında alınan görüntü ve ses kayıtları, eğitimi satın alan diğer kullanıcıların erişimine sunulabilir.',
          'Kişisel verileriniz, hizmet sağlayıcı iş ortakları ve yasal yükümlülükler kapsamında ilgili kurumlarla paylaşılabilir.',
          'KVKK kapsamında verilerinize ilişkin bilgi talep etme, düzeltme, silme ve işlemeye itiraz etme haklarına sahipsiniz. Detaylı bilgi için KVKK Aydınlatma Metni (Detaylı) sayfasını inceleyebilirsiniz.',
        ],
      },
    ],
  },
  {
    slug: 'kvkk-detayli-metin',
    title: 'KVKK Detaylı Metin',
    shortTitle: 'KVKK Detaylı Metin',
    sourceName: 'KVKK DETAYLI METİN.docx',
    summary: 'KVKK süreçlerine ilişkin daha geniş kapsamlı açıklamalar ve operasyon detayları bu belgede yer alır.',
    sections: [
      {
        heading: '1. Veri Sorumlusu',
        paragraphs: [
          'Kişisel verileriniz, SYNTERA Eğitim ve Danışmanlık (Özge Yüksel Babaoğlu) tarafından, 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında veri sorumlusu sıfatıyla işlenmektedir.',
        ],
      },
      {
        heading: '2. İşlenen Kişisel Veriler',
        paragraphs: [
          'Aşağıdaki kişisel veriler işlenebilmektedir:',
        ],
        bullets: [
          'Kimlik ve iletişim bilgileri: ad, soyad, e-posta, telefon',
          'Finansal veriler: fatura bilgileri, ödeme bilgileri (kart verileri ödeme kuruluşları tarafından işlenir)',
          'İşlem ve kullanım verileri: satın alma geçmişi, eğitim katılım bilgileri, platform kullanım verileri',
          'Teknik veriler: IP adresi, cihaz bilgisi, log kayıtları',
          'Görsel ve işitsel veriler: canlı eğitimler sırasında elde edilen görüntü ve ses kayıtları',
        ],
      },
      {
        heading: '3. Kişisel Verilerin Toplanma Yöntemi',
        paragraphs: [
          'Kişisel verileriniz; web sitesi üyelik formları, satın alma süreçleri, canlı eğitim katılımı, çerezler ve teknik sistemler aracılığıyla elektronik ortamda toplanmaktadır.',
        ],
      },
      {
        heading: '4. Kişisel Verilerin İşlenme Amaçları',
        bullets: [
          'Eğitim hizmetlerinin sunulması',
          'Üyelik süreçlerinin yürütülmesi',
          'Satış ve ödeme işlemlerinin gerçekleştirilmesi',
          'Eğitim kayıtlarının oluşturulması',
          'Müşteri deneyiminin geliştirilmesi',
          'Teknik süreçlerin yönetilmesi',
          'Yasal yükümlülüklerin yerine getirilmesi',
        ],
      },
      {
        heading: '5. Görüntü ve Ses Kayıtları',
        paragraphs: [
          'Canlı eğitimler sırasında katılımcıların görüntüleri, sesleri ve isim bilgileri kayıt altına alınabilir.',
          'Bu kayıtlar eğitim içeriklerinin bir parçası olarak saklanabilir ve ilgili eğitimi satın alan diğer kullanıcıların erişimine sunulabilir. Bu veri işleme faaliyeti açık rızanıza dayanır.',
        ],
      },
      {
        heading: '6. Kişisel Verilerin Aktarılması',
        paragraphs: [
          'Kişisel verileriniz; ödeme hizmet sağlayıcıları, eğitim ve altyapı platform sağlayıcıları, hosting ve bulut hizmet sağlayıcıları ve hukuken yetkili kamu kurumları ile KVKK’nın 8 ve 9. maddelerine uygun şekilde paylaşılabilir.',
        ],
      },
      {
        heading: '7. Hukuki Sebepler',
        bullets: [
          'Sözleşmenin kurulması ve ifası',
          'Hukuki yükümlülüklerin yerine getirilmesi',
          'Veri sorumlusunun meşru menfaatleri',
          'Açık rızanız',
        ],
      },
      {
        heading: '8. Veri Saklama Süresi',
        paragraphs: [
          'Kişisel verileriniz ilgili mevzuatta öngörülen süreler boyunca veya işleme amacının gerektirdiği süre kadar saklanır; sonrasında silinir, yok edilir veya anonim hale getirilir.',
        ],
      },
      {
        heading: '9. KVKK Kapsamındaki Haklarınız',
        bullets: [
          'Verilerinizin işlenip işlenmediğini öğrenme',
          'İşlenmişse bilgi talep etme',
          'Düzeltme isteme',
          'Silinmesini talep etme',
          'İşlemeye itiraz etme',
        ],
      },
      {
        heading: '10. Başvuru Yöntemi',
        paragraphs: [
          'Taleplerinizi info@syntera.tr e-posta adresi üzerinden iletebilirsiniz. Başvurularınız KVKK kapsamında değerlendirilerek yasal süre içinde yanıtlanır.',
        ],
      },
    ],
  },
  {
    slug: 'acik-riza-metni',
    title: 'Açık Rıza Metni',
    shortTitle: 'Açık Rıza Metni',
    sourceName: 'AÇIK RIZA METNİ.docx',
    summary: 'Açık rıza gerektiren veri işleme süreçleri için kullanıcı bilgilendirmesi bu metin üzerinden sunulur.',
    sections: [
      {
        heading: 'Açık Rıza Metni (Görüntü ve Ses Kaydı)',
        paragraphs: [
          'SYNTERA Eğitim ve Danışmanlık tarafından sunulan canlı eğitimlere katılım kapsamında aşağıdaki hususların bilindiği ve kabul edildiği beyan edilir:',
        ],
        bullets: [
          'Canlı eğitim sırasında görüntünün, sesin ve kullanıcı bilgilerinin kayıt altına alınabileceği',
          'Bu kayıtların eğitim içeriğinin bir parçası olarak saklanabileceği',
          'Söz konusu kayıtların ilgili eğitimi satın alan diğer kullanıcıların erişimine sunulabileceği',
        ],
      },
      {
        heading: 'Kabul ve Geri Çekme Hakkı',
        paragraphs: [
          'Bu kapsamda kişisel verilerin işlenmesine ve paylaşılmasına açık rıza verildiği kabul edilir.',
          'Bu rızanın eğitim hizmetinin sunulabilmesi amacıyla alındığı ve dilediğiniz zaman geri çekme hakkınız bulunduğu bilinmektedir.',
        ],
      },
    ],
  },
  {
    slug: 'cerez-politikasi',
    title: 'Çerez Politikası',
    shortTitle: 'Çerez Politikası',
    sourceName: 'ÇEREZ POLİTİKASI.docx',
    summary: 'Sitede kullanılan çerez türleri, amaçları ve tercih yönetimi bilgileri bu sayfada bulunur.',
    sections: [
      {
        heading: 'Çerez Kullanımı',
        paragraphs: [
          'Web sitemiz, kullanıcı deneyimini geliştirmek amacıyla çerezler kullanmaktadır.',
          'Siteyi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.',
        ],
        bullets: [
          'Site performansını artırır',
          'Tercihlerinizi hatırlar',
          'Analiz yapmamıza yardımcı olur',
        ],
      },
    ],
  },
  {
    slug: 'goruntu-ve-ses-kullanim-onay-metni',
    title: 'Görüntü ve Ses Kullanım Onay Metni',
    shortTitle: 'Görüntü ve Ses Onayı',
    sourceName: 'GÖRÜNTÜ VE SES KULLANIM ONAY METNİ.docx',
    summary: 'Görüntü ve ses kaydı kullanımına dair onay süreçleri bu belge ile yürütülür.',
    sections: [
      {
        heading: 'Onay Metni',
        paragraphs: [
          'SYNTERA Eğitim ve Danışmanlık tarafından düzenlenen canlı eğitimlere katılım kapsamında canlı yayın sırasında görüntünün, sesin ve kullanıcı bilgilerinin kayıt altına alınabileceği bilinmektedir.',
          'Bu kayıtların eğitim içeriklerinin bir parçası olarak saklanabileceği ve ilgili eğitimi satın alan diğer kullanıcıların erişimine sunulabileceği kabul edilir.',
          'Kayıtların yalnızca eğitim, gelişim ve içerik sunumu amacıyla kullanılacağı bilinmekte; bu kapsamda kişisel verilerin işlenmesine ve sınırlı şekilde paylaşılmasına açık rıza verildiği kabul, beyan ve taahhüt edilir.',
          'Ayrıca, bu rızayı dilediğiniz zaman geri çekme hakkınız bulunduğu bilinmektedir.',
        ],
      },
    ],
  },
];

export const LEGAL_DOCUMENTS_BY_SLUG = Object.fromEntries(
  LEGAL_DOCUMENTS.map((document) => [document.slug, document]),
);

export const getLegalDocument = (slug) => LEGAL_DOCUMENTS_BY_SLUG[slug] || null;